<template>
  <div class="bgacontactsearch">
    <b-container>
      <div v-cloak>
        <b-alert
            :show="showAlert"
            variant="danger"
        >
          {{ error }}
        </b-alert>
        <template v-if="authorized">

          <b-form ref="contacts" @submit.prevent="updateData">

            <div class="accordion" role="tablist">

              <cm-card card-title="Carriers to include in search"
                       toggle="accordion-carriers">
                <b-form-checkbox
                    v-for="carrier in carriers"
                    :key="carrier.id"
                    v-model="selectedCarriers"
                    :value="carrier.id"
                >
                  <span v-html="carrier.name"></span>
                </b-form-checkbox>

              </cm-card>

              <div class="d-flex justify-content-between align-items-center">
                <b-button variant="success" v-on:click="updateData">{{this.buttonText}}</b-button>
                <img style="width:120px" src="https://carriermatrix.com/wp-content/uploads/Engineered-By-Simplicity.jpg"  alt="Engineered By Simplicity Group">
              </div>


            </div>
          </b-form>

        </template>
      </div>
    </b-container>
  </div>
</template>

<script>
import {bus} from "@/event-bus";
import HelperFunctions from "@/mixins/helper-functions"

export default {
  name: "BGAContactSearch",
  mixins: [HelperFunctions],
  data() {
    return {
      items: [],
      error: '',
      query_args: '',
      showAlert: false,
      dontPreselectCarriers: true
    }
  },
  mounted() {

    this.fetchCarriers().catch(error => {
      console.error(error)
    })

  },
  methods: {

    updateResults() {
      bus.$emit("update-contact-results-items", this.items);
    },

    async updateData() {
      this.items = []
      this.updateResults()
      this.showAlert = false
      if (!this.selectedCarriers.length) {
        this.showAlert = true
        this.error = 'At least one Carrier needs to be selected'
        this.scrollToTop()
        return
      }
      const formData = new FormData(this.$refs['contacts'])
      formData.append('selected_carriers', this.selectedCarriers)
      formData.append('agency_id', this.agencyId)
      formData.append('api_key', this.apiKey)
      formData.append('site', window.location.href)
      const data = {}
      for (let [key, val] of formData.entries()) {
        Object.assign(data, {[key]: val})
      }
      const params = new URLSearchParams(data)
      const options = {
        headers: new Headers(),
      }
      this.items = await fetch(this.$hostname + '/cm_api/cm/v1/contact-api?' + params, options)
          .then(res => {
            return res.json()
          })
          .then(items => items)
      if (!this.items.length) {
        this.showAlert = true
        this.error = 'There are no contacts added for the selected Carriers'
        this.scrollToTop()
        return
    }
      if (this.items.error) {
        this.showAlert = true
        this.error = this.items.error.message
        this.query_args = this.items.error.query_args
        this.scrollToTop()
      }
      this.updateResults()
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
